import { Suspense, useEffect, useRef } from 'react'
import './App.css'
import Layout from './component/web/layout/layout'
import { Route, Switch } from 'react-router-dom'
import { lstPrivateRoutes, lstPublicRoutes } from './router/routesConfig'
import Dialog from './control/dialog/dialog'
import useAppAlertMessageStore from './stores/appAlertMessage/appAlertMessageStore'
import useAppAlertMessageAction from './stores/appAlertMessage/appAlertMessageAction'
import PrivateRoute from './router/privateRoute'
import Loading from './control/loading/loading'
import useLoading from './control/loading/useLoading'
import { MySnackbarView } from './control/snackbar/snackbar'
import useSnackbarStore from './stores/snackbar/snackbarStore'
import useSnackbarAction from './stores/snackbar/snackbarAction'
import { QueryParamProvider } from 'use-query-params'
import BGLoading from './control/bgLoading/bgLoading'

const useApplicationAlertMessage = () => {
    const appAlertMessageRef = useRef<Record<string, Function>>()

    const appAlertMessageStore = useAppAlertMessageStore()
    const appAlertMessageAction = useAppAlertMessageAction()

    const snackbarStore = useSnackbarStore()
    const snackbarAction = useSnackbarAction()
    useEffect(() => {
        if (appAlertMessageRef.current) {
            if (appAlertMessageStore.isOpen) {
                appAlertMessageRef.current.openDialog()
            } else {
                appAlertMessageRef.current.closeDialog()
            }
        }
    }, [appAlertMessageStore.isOpen])
    const handleRefAppAlertMessage = (func: Record<string, Function>) => {
        appAlertMessageRef.current = func
    }
    const handleAfterClose = () => {
        appAlertMessageAction.closeAlertMessage()
    }
    return {
        title: appAlertMessageStore.title,
        message: appAlertMessageStore.message,
        onRefAppAlertMessage: handleRefAppAlertMessage,
        onAfterClose: handleAfterClose,
        snackbarConfig: {
            open: snackbarStore.isOpen,
            handleClose: snackbarAction.closeSnackbar,
            handleOpen: snackbarAction.openSnackbar,
            message: snackbarStore.message,
            type: snackbarStore.type,
        },
    }
}

declare global {
    interface Window {
        acceptanceContentTH: string
        acceptanceContentEN: string
    }
}

function App() {
    const applicationAlertMessageModel = useApplicationAlertMessage()
    const loadingHook = useLoading()
    return (
        <Suspense fallback={<BGLoading />}>
            <Switch>
                {lstPublicRoutes.map((route) => {
                    return (
                        <Route key={route.menuID} path={route.path} component={route.component} exact={route.exact} />
                    )
                })}

                <QueryParamProvider ReactRouterRoute={Route}>
                    <Layout>
                        {lstPrivateRoutes.map((route) => {
                            return (
                                <PrivateRoute
                                    key={route.menuID}
                                    path={route.path}
                                    component={route.component}
                                    exact={route.exact}
                                    functionID={route.functionID}
                                />
                            )
                        })}
                    </Layout>
                </QueryParamProvider>
            </Switch>
            <MySnackbarView {...applicationAlertMessageModel.snackbarConfig} />
            <Dialog
                type="alert-message"
                onRef={applicationAlertMessageModel.onRefAppAlertMessage}
                title={applicationAlertMessageModel.title}
                content={applicationAlertMessageModel.message}
                onAfterClose={applicationAlertMessageModel.onAfterClose}
            />
            <Loading isShowLoading={loadingHook.configLoading.isShowLoading} />
        </Suspense>
    )
}

export default App
